export const CATEGORY = {
  TECH_BUGS: 'tech_bugs',
  ORDER_SYNC: 'order_sync',
  APP_ISSUE: 'app_issue',
  EDIT_PROFILE: 'edit_profile',
  LOGIN_ISSUES_WEBSITE: 'login_issues_website',
  MEDICAL_ESCALATIONS: 'medical_escalations',
  HAIRFALL_ISSUE: 'hairfall_issue',
  CONSTIPATION_ISSUE: 'constipation_issue',
  DANDRUFF_ISSUE: 'dandruff_issue',
  HEALTH_ISSUE: 'health_issue',
  ITCHING_ISSUE: 'itching_issue',
  PRODUCT_REACTION_ISSUE: 'product_reaction_issue',
  SEXUAL_ISSUE: 'sexual_issue',
  GASTRIC_ISSUE: 'gastric_issue',
  OTHER_ISSUE: 'other_issue',
  DOCTOR_FOLLOWUP:'follow_up_call',
  FIVE_MONTHS_NO_RESULTS: 'five_months_no_results',
  DETERIORATION: 'deterioration',
  DOCTOR_CALL: 'doctor_call',
  ORDER_RELATED: 'order_related',
  DELIVERY_RELATED_ISSUES: 'delivery_related_issues',
  ORDER_CANCELLATION: 'order_cancellation',
  REVERSE_PICK_UP: 'reverse_pick_up',
  PRODUCT_CHANGE: 'product_change',
  RETURN_FOR_COD_ORDERS: 'return_for_cod_orders',
  DAMAGED_PRODUCT: 'damaged_product',
  MISSING_PRODUCT: 'missing_product',
  MISMATCH_PRODUCT: 'mismatch_product',
  PRODUCT_CORRECTION: 'product_correction',
  DELIVERY_ISSUES: 'delivery_Issues',
  ORDER_DELAYED: 'order_delayed',
  REATTEMPT_REQUEST: 'reattempt_request',
  INITIATE_RTO: 'initiate_rto',
  TRACKING_LINK_NOT_UPDATED: 'tracking_link_Not_updated',
  WRONG_TRACKING_STATUS: 'wrong_tracking_status',
  AMOUNT_PAID_NO_ORDER: 'amount_paid_no_order',
  MONEY_DEDUCTED_ORDER_NOT_PLACED: 'money_deducted_but_order_not_placed',
  PAYMENTS: 'payments',
  PAYMENT_RELATED_ISSUES: 'payment_related_issues',
  DOCTOR_CONSULTATION_FEE_REFUND: 'doctor_consultation_fee_refund',
  PAYMENTS_ISSUE: 'payments_issue',
  ORDER_RELATED_REFUNDS: 'order_related_refunds',
  PAYMENT_FAILURE: 'payment_failure',
  REFERRAL_CODE: 'referral_code',
  CUSTOMER_COMPLAINTS: 'feedback',
  FIVE_MONTH_MONEY_BACK: 'five_month_money_back',
  COACH_SERVICE: 'coach_service',
  ANGRY_CUSTOMER: 'angry_customer',
  NO_RESULTS_TRAYA: 'no_results_traya',
  NEGATIVE_REVIEW: 'negative_review',
  SLOT_MISSED: 'slot_missed',
  SLOT_NOT_CATERED: 'slot_not_catered',
  CUSTOMER_OTHERS: 'customer_others',
  JAGDKASGDKGAK: 'jagdkasgdkgak',
  ASKDAKSHJAKS: 'askdakshjaks',
  ASDJNASD: 'asdjnasd',
  AAAAAAADD: 'aaaaaaadd',
  BBBBBB: 'bbbbbb',
  MEDICAL_DOCUMENT: 'medical_document',
  RETURN_REQUEST: 'return_request',
  TESTING_SUBCATEGORY_TWO: 'testing_subcategory_two',
  PRODUCT_RELATED_QUALITY_ISSUES: 'product_related_quality_issues',
  HAIR_RAS: 'hair_ras',
  NEGATIVE_REVIEWS_ORM: 'negative_reviews_orm',
  HEALTH_TATVA: 'health_tatva',
  SCALP_OIL_BOOSTER_OILS: "scalp_oil_'booster_oils'",
  GUTT_SHUDDHI: 'gutt_shuddhi',
  NASAL_GRIT: 'nasal_grit',
  DIGEST_BOOST: 'digest_boost',
  CONSTI_CLEAR: 'consti_clear',
  CHOLEST_VATI: 'cholest_vati',
  PCOS_SANTULAN: 'pcos_santulan',
  THYRO_SANTULAN: 'thyro_santulan',
  HER_SANTULAN_: 'her_santulan_',
  MOM_SANTULAN: 'mom_santulan',
  MINOXIDIL_2: 'minoxidil_2%',
  MINOXIDIL_5: 'minoxidil_5%',
  ANTI_DANDRUFF_SHAMPOO: 'anti_dandruff_shampoo',
  ANTI_DANDRUFF_NIGHT_LOTION: 'anti_dandruff_night_lotion',
  DEFENCE_SHAMPOO: 'defence_shampoo',
  RECAP_SERUM: 'recap_serum',
  HAIR_VITAMIN: 'hair_vitamin',
  CUTICLE_DAMAGE_RANGE: 'cuticle_damage_range',
  NOURISH_HAIR_OIL_: 'nourish_hair_oil_',
  NEW_PRODUCT_SUGGESTION_: 'new_product_suggestion_',
  TESTINGONE: 'testingone',
  ADLNKADS: 'adlnkads',
  TESTINGONETWO: 'testingonetwo',
  TESTINGTWO: 'testingtwo',
  AFJSFKBSF: 'afjsfkbsf',
  TESTING_ONE: 'testing_one',
  TESTING_AGAIN_ONE: 'testing_again_one',
  TESTING_THREE: 'testing_three',
  TESTING_THREE_TWO: 'testing_three_two',
  TESTING_FAQ_ASSIGNEE_SUBCATEGORY: 'testing_faq_assignee_subcategory',
  FOLLOW_UP: 'follow_up',
  TESTING_CATEGORY: 'testing_category',
  TESTING_SUBCATEGORY: 'testing_subcategory',
  TESTING_TWIO_: 'testing_twio_',
  AUTO_PREPAID_RTO: 'return_for_prepaid_order',
  RETURN_FOR_PREPAID_ORDER: 'return_for_prepaid_order',
  AUTO_ORDER_CANCELLATION_INITIATED: 'auto_order_cancellation_initiated',
  COMMUNITY_ESCALATION: 'community_escalation',
  INTERNAL_TICKET: 'internal_ticket',
  DSAT_CALLING: 'dsat_calling'
};

export const categories = {
  [CATEGORY.TECH_BUGS]: 'Tech Issues',
  [CATEGORY.ORDER_SYNC]: 'Order sync',
  [CATEGORY.APP_ISSUE]: 'App issue ',
  [CATEGORY.EDIT_PROFILE]: 'Edit profile',
  [CATEGORY.LOGIN_ISSUES_WEBSITE]: 'Login Issue on website',
  [CATEGORY.MEDICAL_ESCALATIONS]: 'Medical Escalations',
  [CATEGORY.HAIRFALL_ISSUE]: 'Hairfall',
  [CATEGORY.CONSTIPATION_ISSUE]: 'Constipation',
  [CATEGORY.DANDRUFF_ISSUE]: 'Dandruff',
  [CATEGORY.HEALTH_ISSUE]: 'Health conditions',
  [CATEGORY.ITCHING_ISSUE]: 'Itching',
  [CATEGORY.PRODUCT_REACTION_ISSUE]: 'Product Reaction ',
  [CATEGORY.SEXUAL_ISSUE]: 'Sexual issue',
  [CATEGORY.GASTRIC_ISSUE]: 'Gastric issues',
  [CATEGORY.OTHER_ISSUE]: 'Other Medical Issues',
  [CATEGORY.MEDICAL_DOCUMENT]: 'Medical Document',
  [CATEGORY.FOLLOW_UP]: 'Follow Up',
  [CATEGORY.FIVE_MONTHS_NO_RESULTS]: 'Five Months No Results',
  [CATEGORY.DETERIORATION]: 'Deterioration',
  [CATEGORY.DOCTOR_CALL]: 'Doctor Call',
  [CATEGORY.ORDER_RELATED]: 'Order Related',
  [CATEGORY.ORDER_CANCELLATION]: 'Order Cancellation',
  [CATEGORY.REVERSE_PICK_UP]: 'Reverse Pick Up',
  [CATEGORY.PRODUCT_CHANGE]: 'Product Change',
  [CATEGORY.RETURN_FOR_COD_ORDERS]: 'Return For COD Orders',
  [CATEGORY.DAMAGED_PRODUCT]: 'Damaged Product',
  [CATEGORY.MISSING_PRODUCT]: 'Missing Product ',
  [CATEGORY.DELIVERY_RELATED_ISSUES]: 'Delivery Related Issues',
  [CATEGORY.MISMATCH_PRODUCT]: 'Mismatch Product',
  [CATEGORY.PRODUCT_CORRECTION]: 'Product Correction',
  [CATEGORY.DELIVERY_ISSUES]: 'Delivery Issues',
  [CATEGORY.REATTEMPT_REQUEST]: 'Reattempt Request',
  [CATEGORY.INITIATE_RTO]: 'Initiate RTO',
  [CATEGORY.TRACKING_LINK_NOT_UPDATED]: 'Tracking Link Not Updated',
  [CATEGORY.WRONG_TRACKING_STATUS]: 'Incorrect Tracking Status',
  [CATEGORY.AMOUNT_PAID_NO_ORDER]: 'Amount Paid But Not Handed Over',
  [CATEGORY.PAYMENTS]: 'Payment Issue',
  [CATEGORY.PAYMENTS_ISSUE]: 'Payment Issue',
  [CATEGORY.ORDER_RELATED_REFUNDS]: 'Order Related Refunds',
  [CATEGORY.DOCTOR_CONSULTATION_FEE_REFUND]: 'Doctor Consultation Fee Refund',
  [CATEGORY.PAYMENT_FAILURE]: 'Payment Failure No Order Placed',
  [CATEGORY.REFERRAL_CODE]: 'Referall Code',
  [CATEGORY.FIVE_MONTH_MONEY_BACK]: 'Five Month Money Back',
  [CATEGORY.CUSTOMER_COMPLAINTS]: 'Customer Complaints',
  [CATEGORY.FIVE_MONTH_MONEY_BACK]: 'Five month money back',
  [CATEGORY.COACH_SERVICE]: 'Coach service',
  [CATEGORY.ANGRY_CUSTOMER]: 'Angry Customer',
  [CATEGORY.NO_RESULTS_TRAYA]: 'No Result with Traya',
  [CATEGORY.NEGATIVE_REVIEW]: 'Negative Review ',
  [CATEGORY.SLOT_MISSED]: 'Slot Completely Missed',
  [CATEGORY.SLOT_NOT_CATERED]: 'Slot not Catered On Time',
  [CATEGORY.CUSTOMER_OTHERS]: 'Other Customer Issue',
  [CATEGORY.JAGDKASGDKGAK]: 'Jagdkasgdkgak',
  [CATEGORY.ASKDAKSHJAKS]: 'Askdakshjaks',
  [CATEGORY.ASDJNASD]: 'Asdjnasd',
  [CATEGORY.AAAAAAADD]: 'Aaaaaaadd',
  [CATEGORY.BBBBBB]: 'Bbbbbb',
  [CATEGORY.MEDICAL_DOCUMENT]: 'Medical Document',
  [CATEGORY.RETURN_REQUEST]: 'Return Request',
  [CATEGORY.TESTING_SUBCATEGORY_TWO]: 'Testing Subcategory Two',
  [CATEGORY.PRODUCT_RELATED_QUALITY_ISSUES]: 'Product Related Quality Issues',
  [CATEGORY.HAIR_RAS]: 'Hair Ras',
  [CATEGORY.NEGATIVE_REVIEWS_ORM]: 'Negative Reviews ORM',
  [CATEGORY.HEALTH_TATVA]: 'Health Tatva',
  [CATEGORY.SCALP_OIL_BOOSTER_OILS]: 'Scalp Oil / Booster Oils',
  [CATEGORY.GUTT_SHUDDHI]: 'Gutt Shuddhi',
  [CATEGORY.NASAL_GRIT]: 'Nasal Grit',
  [CATEGORY.DIGEST_BOOST]: 'Digest Boost',
  [CATEGORY.CONSTI_CLEAR]: 'Consti Clear',
  [CATEGORY.CHOLEST_VATI]: 'Cholest Vati',
  [CATEGORY.PCOS_SANTULAN]: 'PCOS Santulan',
  [CATEGORY.THYRO_SANTULAN]: 'Thyro Santulan',
  [CATEGORY.HER_SANTULAN_]: 'Her Santulan ',
  [CATEGORY.MOM_SANTULAN]: 'Mom Santulan',
  [CATEGORY.MINOXIDIL_2]: 'Minoxidil 2%',
  [CATEGORY.MINOXIDIL_5]: 'Minoxidil 5%',
  [CATEGORY.ANTI_DANDRUFF_SHAMPOO]: 'Ketoconazole Anti Dandruff Shampoo',
  [CATEGORY.ANTI_DANDRUFF_NIGHT_LOTION]: 'Anti-Dandruff Night Lotion',
  [CATEGORY.DEFENCE_SHAMPOO]: 'Defence Shampoo',
  [CATEGORY.RECAP_SERUM]: 'Recap Serum',
  [CATEGORY.HAIR_VITAMIN]: 'Hair Vitamin',
  [CATEGORY.CUTICLE_DAMAGE_RANGE]: 'Cuticle Damage Range',
  [CATEGORY.NOURISH_HAIR_OIL_]: 'Nourish Hair Oil ',
  [CATEGORY.NEW_PRODUCT_SUGGESTION_]: 'New Product Suggestion ',
  [CATEGORY.TESTINGONE]: 'TestingOne',
  [CATEGORY.ADLNKADS]: 'Adlnkads',
  [CATEGORY.TESTINGONETWO]: 'Testingonetwo',
  [CATEGORY.TESTINGTWO]: 'TestingTwo',
  [CATEGORY.AFJSFKBSF]: 'Afjsfkbsf',
  [CATEGORY.TESTING_ONE]: 'Testing One',
  [CATEGORY.TESTING_AGAIN_ONE]: 'Testing Again One',
  [CATEGORY.TESTING_THREE]: 'Testing Three',
  [CATEGORY.TESTING_THREE_TWO]: 'Testing THree Two',
  [CATEGORY.TESTING_FAQ_ASSIGNEE_SUBCATEGORY]: 'Testing FAQ Assignee Subcategory',
  [CATEGORY.FOLLOW_UP]: 'Follow Up',
  [CATEGORY.TESTING_CATEGORY]: 'Testing Category',
  [CATEGORY.TESTING_SUBCATEGORY]: 'Testing Subcategory',
  [CATEGORY.TESTING_TWIO_]: 'Testing Twio ',
  [CATEGORY.AUTO_PREPAID_RTO]: 'Return For Prepaid Order',
  [CATEGORY.RETURN_FOR_PREPAID_ORDER]: 'Return For Prepaid Order',
  [CATEGORY.AUTO_ORDER_CANCELLATION_INITIATED]: 'Auto Order Cancellation Initiated',
  [CATEGORY.COMMUNITY_ESCALATION]: 'community Escalation',
  [CATEGORY.DOCTOR_FOLLOWUP]: 'Follow Up Call',
  [CATEGORY.INTERNAL_TICKET]: 'Internal Ticket',
  [CATEGORY.DSAT_CALLING]: 'DSAT Calling'
};

export const TICKET_STATUS = {
    ON_HOLD: 'On Hold',
    OPEN: 'Open',
	PENDING: 'Pending',
	RESOLVED: 'Resolved',
	CLOSED: 'Closed'
};

export const TICKET_STATUS_CODE = {
    ON_HOLD: 1,
    OPEN: 2,
	PENDING: 3,
	RESOLVED: 4,
	CLOSED: 5
};
export const CUSTOMER_COMPLAINTS_SUBCATS = [CATEGORY.CUSTOMER_OTHERS, CATEGORY.SLOT_NOT_CATERED, CATEGORY.SLOT_MISSED, CATEGORY.NEGATIVE_REVIEW, CATEGORY.NO_RESULTS_TRAYA, CATEGORY.ANGRY_CUSTOMER, CATEGORY.COACH_SERVICE, CATEGORY.FIVE_MONTH_MONEY_BACK, CATEGORY.COMMUNITY_ESCALATION];
